"use client";

import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ServiceArea() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const hours = [{
    label: "DADE COUNTY",
    value: "Available 24/7"
  }, {
    label: "BROWARD",
    value: "Available 24/7"
  }, {
    label: "WEST PALM",
    value: "Available 24/7"
  }];
  return <section data-section-id="1266" id="service-area-map" className="bg-background text-foreground border-t border-border">
      <div ref={ref} className={`max-w-[1440px] mx-auto px-[5vw] py-24 md:py-24 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
      transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)"
    }}>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-10">
          {}
          <div className="lg:col-span-8 order-2 lg:order-1">
            <TooltipProvider delayDuration={150}>
              <Tooltip>
                <TooltipTrigger asChild>
                  <div className="relative w-full cursor-pointer group rounded-lg overflow-hidden border border-border shadow-lg" style={{
                  aspectRatio: "16 / 10"
                }}>
                    {}
                    <span className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-primary pointer-events-none" />
                    <span className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-primary pointer-events-none" />
                    <span className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-primary pointer-events-none" />
                    <span className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-primary pointer-events-none" />

                    <svg viewBox="0 0 800 500" preserveAspectRatio="xMidYMid slice" className="absolute inset-0 w-full h-full" aria-label="Service area map for South Florida">
                      {}
                      <rect width="800" height="500" fill="hsl(210 20% 96%)" />

                      {}
                      <path d="M 200,0 L 800,0 L 800,500 L 200,500 Z" fill="hsl(207 89% 94%)" />

                      {}
                      <g stroke="hsl(223 83% 9%)" strokeWidth="0.5" fill="none" opacity="0.2">
                        <line x1="0" y1="100" x2="800" y2="100" />
                        <line x1="0" y1="250" x2="800" y2="250" />
                        <line x1="0" y1="400" x2="800" y2="400" />
                      </g>

                      {}
                      <g fill="hsl(223 83% 9%)" fontFamily="JetBrains Mono, monospace" fontSize="12" letterSpacing="0.1em" opacity="0.6">
                        <text x="400" y="150" textAnchor="middle">WEST PALM BEACH</text>
                        <text x="400" y="250" textAnchor="middle">BROWARD COUNTY</text>
                        <text x="400" y="350" textAnchor="middle">MIAMI-DADE</text>
                      </g>

                      {}
                      <circle cx="400" cy="250" r="30" fill="hsl(208 72% 50%)" opacity="0.2">
                        <animate attributeName="r" values="20;40;20" dur="3s" repeatCount="indefinite" />
                        <animate attributeName="opacity" values="0.4;0.1;0.4" dur="3s" repeatCount="indefinite" />
                      </circle>

                      {}
                      <circle cx="400" cy="250" r="8" fill="hsl(208 72% 50%)" />
                    </svg>
                  </div>
                </TooltipTrigger>
                <TooltipContent side="top" className="font-mono text-[10px] tracking-[0.16em] uppercase bg-secondary text-secondary-foreground">
                  Serving Dade, Broward, & West Palm Counties
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>

            {}
            <div className="mt-6 flex items-center gap-6">
              <span className="h-px flex-1 bg-border" />
              <span className="font-mono text-[11px] tracking-[0.18em] uppercase text-primary">
                SOUTH FLORIDA · CERTIFIED
              </span>
              <span className="h-px flex-1 bg-border" />
              <span className="block w-2 h-2 bg-primary rounded-lg" />
            </div>
          </div>

          {}
          <div className="lg:col-span-4 order-1 lg:order-2 relative flex flex-col">
            {}
            <div className="lg:absolute lg:-right-2 lg:top-0 lg:h-full flex lg:flex-col items-center lg:items-start gap-3 mb-8 lg:mb-0">
              <span className="font-default text-2xl font-light leading-none text-primary">
                02
              </span>
              <span className="font-mono text-[11px] tracking-[0.22em] uppercase lg:[writing-mode:vertical-rl] lg:rotate-180 text-muted-foreground">
                Service Coverage
              </span>
            </div>

            <div className="lg:pr-10">
              {}
              <h2 className="font-default font-bold leading-[1.2] tracking-tighter mb-8 text-foreground" style={{
              fontSize: "clamp(2rem, 4vw, 3rem)"
            }}>
                Precision Testing Across <span className="text-primary">South Florida</span>
              </h2>

              {}
              <div className="mb-8">
                <p className="font-default font-normal leading-[1.6] text-muted-foreground" style={{
                fontSize: "1.125rem"
              }}>
                  MYB Services provides expert environmental testing and mold inspection services for residential and commercial properties throughout Dade, Broward, and West Palm Beach counties.
                </p>
              </div>

              {}
              <div className="flex items-center gap-4 mb-10">
                <span className="h-px flex-1 bg-border" />
                <span className="font-mono text-[10px] tracking-[0.18em] uppercase whitespace-nowrap text-primary">
                  26 YEARS OF EXPERTISE
                </span>
                <span className="h-px w-4 bg-border" />
                <span className="block w-2 h-2 rounded-lg bg-primary" />
              </div>

              {}
              <div className="mb-10">
                <p className="font-mono text-[11px] tracking-[0.22em] uppercase mb-5 text-muted-foreground">
                  Service Regions
                </p>
                <ul className="flex flex-col">
                  {hours.map((row, i) => <li data-index={i} key={row.label} className="flex items-baseline justify-between py-3 border-t border-border">
                      <span className="font-mono text-[11px] tracking-[0.18em] uppercase text-muted-foreground">
                        {row.label}
                      </span>
                      <span className="font-default font-semibold text-foreground" style={{
                    fontSize: "1rem"
                  }}>
                        {row.value}
                      </span>
                    </li>)}
                  <li className="border-t border-border" />
                </ul>
              </div>

              {}
              <Button asChild className="group rounded-lg bg-primary px-8 py-6 h-auto font-default font-semibold text-primary-foreground hover:bg-primary/90 transition-all">
                <Link to="/ContactPage">
                  <span>Schedule Inspection</span>
                  <ArrowUpRight className="size-4 ml-2 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}